'use client'
import Image from 'next/image';
import { useEffect, useState, useRef } from 'react';
import { Popup,Radio,Toast } from 'antd-mobile';
import s from './StoreDom.module.css'
import closeImg from '@/images/close_36x36_3x.png'

const StoreDom = (props) => {
  const { selectedInfo = {}, callbackFun, storeVisiable, setStoreVisiable } = props;
  const storeInfo = selectedInfo.stores || []
  const [checkedIndex, setCheckedIndex] = useState();
  
  const checkedFun = (e, idx)=>{
    if(e){
      setCheckedIndex(idx)
    }
  }

  const confirm = ()=>{
    
    if(!checkedIndex && checkedIndex !== 0){
      Toast.show({
        content : <div className={s.font12}>请选择您的服务门店</div>
      })
      return false;
    }
    const checkedItem = storeInfo[checkedIndex];

    callbackFun({
      store : checkedItem,
      cityId : selectedInfo.cityId,
      cityCode : selectedInfo.cityAreaId,
      cityName : selectedInfo.cityName,
      citySpell : selectedInfo.citySpell
    })
  }

  return (
    <Popup
      visible={storeVisiable}
      onMaskClick={() => { setStoreVisiable(false) }}
      bodyStyle={{}}
      bodyClassName={s.container}
    >
      <div className={s.contentclass}>
        <div className={s.title}>
          <div>请确认您的服务门店</div>
          <div>
            <Image
              src={closeImg}
              alt=""
              className={s.closeImg}
              onClick={() => { setStoreVisiable(false) }}
            ></Image>
          </div>
        </div>
        <div className={s.storeclass}>
          {storeInfo.map((item,idx) => {
            return (
              <div key={`storeId_${item.storeId}`} className={s.store}>
                <div className={s.left}>
                  <div className={s.left2}>
                    <div className={s.text03}>{item.storeName}</div>
                    <div className={s.text05}>{item.distance}</div>
                  </div>
                  <div className={s.text04}>
                    {item.address}
                  </div>
                </div>
                <div className={s.right}>
                <Radio checked={idx === checkedIndex} onChange={(e)=>{checkedFun(e, idx)}} />
                </div>
              </div>
            )
          })}
        </div>
        <div className={s.btncontent}>
            <div className={`${s.btn} ${s.btn2}`} onClick={(() => {  confirm() })}>确定</div>
          </div>
      </div>
    </Popup>
  )
}

export default StoreDom;